import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
    selector: 'mobile-menu',
    templateUrl: './mobile-menu.component.html',
    styleUrls: ['./mobile-menu.component.scss'],
    standalone: true,
    imports: [MatIconModule, CommonModule, TranslateModule],
})
export class MobileMenuComponent {
    @Input() dropdownValues: {
        label: string;
        href?: string;
        subValues?: {
            description: any;
            label: string;
            href: string;
            hasBadge: boolean;
        }[];
    }[] = [];
    @Input() label: string = '';
    @Input() borderBottom: boolean = false;
    @Input() dropDown: boolean = false;
    @Input() href: string = '';

    isDropdownOpen: boolean | string = false;
    subDropDownOpen: { [key: string]: boolean } = {};

    constructor(private router: Router) {}

    toggleDropdown(e) {
        if (this.isDropdownOpen === e) {
            this.closeDropdown();
            return;
        }
        this.isDropdownOpen = e;
    }

    closeDropdown() {
        this.isDropdownOpen = false;
    }

    subDropDownOpenHandle(subDropDownIndex) {
        if (this.subDropDownOpen[subDropDownIndex]) {
            this.subDropDownOpen[subDropDownIndex] = false;
        } else {
            this.subDropDownOpen[subDropDownIndex] = true;
        }
    }

    redirect() {
        if (this.dropDown == false) {
            this.router.navigate([this.href]);
        }
    }
}
